import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

import './Imagination.scss';

export const OnboardingPaywallImagination: React.FC = () => {
  return (
    <section className="imagination">
      <UiTypography className="title" variant="title-large">
        Feel truly special,{' '}
        <UiTypography variant="title-large" component="span" color="gradient">
          get your imagination run wild
        </UiTypography>
        , and chat freely with Dialogue
      </UiTypography>
    </section>
  );
};
